import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './resources';

const i18n = createInstance();

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'de',
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
  debug: process.env.NODE_ENV === 'development',
});

export default i18n;
